import { render, staticRenderFns } from "./StudentTransferToSession.vue?vue&type=template&id=735d2c31&"
import script from "./StudentTransferToSession.vue?vue&type=script&lang=js&"
export * from "./StudentTransferToSession.vue?vue&type=script&lang=js&"
import style0 from "./StudentTransferToSession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports